module.exports = __webpack_public_path__ + "static/3-5c130c41b36813866e1f0375d1bea634.jpeg";